<template>
  <div id="app_p">
    <h2>身份验证登录</h2>
    <div class="contain">
      <div class="input">
        <input-box
          class="teltop"
          @input="phonewrite"
          number="11"
          :testtextbool.sync="tishi"
          v-model="telnum"
          placeholder="请输入手机号码"
        >
        </input-box>
        <img v-if="telnum" width="20px" style="margin-right:10px;width:20px" src="../../assets/clear@2x.png" @click="close" />
      </div>
      <text-box
        v-if="tishi"
        showtel="手机号必须是数字，且精确到11位数"
        :testtextbool.sync="tishi"
      ></text-box>
      <input-box
        style="cursor:pointer"
        v-model="testnum"
        @input="codewrite"
        number="1"
        :testtextbool.sync="tishicode"
        :timecount.sync="timecount"
        @codeclick="sendcode"
        :rtest="codetestR"
        placeholder="请输入验证码"
      >
      </input-box>
      <text-box
        v-if="tishicode"
        showtel="验证码为4位数"
        :testtextbool.sync="tishicode"
      ></text-box>
      <van-notify v-model="testshowinfo" type="success">
        <van-icon name="bell" style="margin-right: 4px" />
        <span>发送验证码成功</span>
      </van-notify>
      <button class="contain_subm" @click="submit">登录</button>
    </div>
  </div>
</template>

<script>
import ArticleItem from "@/components/article-item/index.vue";
import headerBox from "@/components/header.vue";
import textBox from "@/components/textbox.vue";
import inputBox from "@/components/input.vue";
import { Loginidentfy, sendmessage } from "../../api/apitotal.js";
export default {
  name: "app_p",
  components: {
    ArticleItem,
    inputBox,
    headerBox,
    textBox,
  },
  data() {
    return {
      telnum: "",
      testnum: "",
      tishi: false,
      timecount: false,
      tishicode: false,
      codeRboolen: false,
      codetestR: "发送验证码",
      testshowinfo: false,
      wxAppId: ''
    }
  },
  mounted() {
    if (
      this.telnum.trim().length == 0 ||
      this.testnum.trim().length == 0 ||
      this.tishi ||
      this.tishicode
    ) {
      document.getElementsByClassName("contain_subm")[0].style.background =
        "rgba(84, 176, 251, 0.5)";
      document.getElementsByClassName("contain_subm")[0].style.color = "white";
    }
    // this.getword();
  },
  methods: {
    getWxAppId() {
      return new Promise((revolve)=>{
        this.$http.get('/auth/appId', { //获取appId
          params: { url: location.href } 
        }).then(res => {
          if(res.data.success){
            revolve(res.data.msg)
          }
        })
      })
    },
    close() {
      // console.log(11);
      this.telnum = "";
    },
    phonewrite() {},
    codewrite() {
      //         if(this.telnum.trim().length==0||this.testnum.trim().length==0||this.tishi||this.tishicode){

      //   return false
      //  }

      if (this.tishi || this.tishicode) {
        document.getElementsByClassName("contain_subm")[0].style.background =
          "rgba(84, 176, 251, 0.5)";
        document.getElementsByClassName("contain_subm")[0].style.color =
          "white";
      } else {
        document.getElementsByClassName("contain_subm")[0].style.background =
          "#54B0FB";
        document.getElementsByClassName("contain_subm")[0].style.color =
          "white";
      }
    },
    sendcode() {
      //  if(this.codetestR!='发送验证码'){
      //        document.getElementsByClassName('contain_subm')[0].style.color="rgba(153,153,153,1)"

      //  }
      if (
        this.telnum.trim().length == 0 ||
        this.tishi ||
        this.codetestR != "发送验证码"
      ) {
        return false;
      }

      // this.telnum='13715187766'
      const params = {
        mobileNo: this.telnum,
        uuid: 1,
      };

      this.$http.get("/auth/sms/send", { params }).then((res) => {
        console.log(res.data);
        if (res.data.success && res.status == "200") {
          this.codetestR = "60";
          document.getElementsByClassName("sendcodew")[0].style.color =
            "rgba(153,153,153,1)";
          this.testshowinfo = true;
          setTimeout(() => {
            this.testshowinfo = false;
          }, 1000);
        }
      });

      var timer = setInterval(() => {
        this.codetestR = this.codetestR - 1;
        if (this.codetestR == 0) {
          clearInterval(timer);
          timer = null;
          this.codetestR = "发送验证码";
          setTimeout(() => {
            if (document.getElementsByClassName("sendcodew")) {
              document.getElementsByClassName("sendcodew")[0].style.color =
                "#54B0FB";
            }
          });
        }
      }, 1000);
      console.log(this.codetestR);
    },
    submit() {
      if (
        this.telnum.trim().length == 0 ||
        this.testnum.trim().length == 0 ||
        this.tishi ||
        this.tishicode
      ) {
        return false;
      }

      if (this.tishi || this.tishicode) {
        return false;
      }
      const params = {
        mobileNo: this.telnum,
        code: this.testnum,
        uuid: 1,
      };

      // this.$http.post("/auth/sms/login", params).then((res) => {
      this.$http.post("/auth/sms/adduser", params).then((res) => {
        if (res.data.success) {
          // localStorage.setItem("card", res.data.data.authentication.card);
          // localStorage.setItem("userId", res.data.data.authentication.userId);
          // localStorage.setItem("phone", this.telnum);
          // localStorage.setItem("Score", res.data.data.authentication.roleJs);
          // localStorage.setItem("tokenn", res.data.data.authentication.token);
          this.doWxLogin();
          this.$router.replace("/index");

        } else {
          alert(res.data.msg);
        }
      });
    },
    doWxLogin: async function() {
      let wxAppId = await this.getWxAppId()
      // console.log(wxAppId)
      const url =`${this.$server.wxLogin}?appid=${wxAppId}&redirect_uri=${encodeURIComponent(this.$server.wxRedirectUrl)}&response_type=code&scope=snsapi_userinfo&state=STATE&connect_redirect=1#wechat_redirect`;
      window.location.replace(url);
    },
  },
};
</script>

<style lang="less" scoped>
#app_p {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: url(../../assets/background.png);
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  padding-top: 100px;
}
h2 {
  width: 100%;
  height: 66px;
  text-align: center;
}
.input {
  position: relative;
  img {
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
  }
}
.rightcha {
  float: left;
}
.contain {
  width: 100%;
  margin: auto;
  padding: 0 50px;
  box-sizing: border-box;
  position: relative;
  margin-top: 60px;
}
.teltop {
  margin: 80px 0 0 0px !important;
}
.contain_subm {
  margin-top: 110px;
  color: @whitee;
  background: #54B0FB;
  border: 0;
  height: @inputheight;
  border-radius: @circle;
  width: 100%;
  height: 80px;
  cursor: pointer;
}
.cat-input {
  margin-top: 40px;
  height: @inputheight;
}
#top {
  text-align: center;
  height: 176px;
  box-sizing: border-box;
  padding-top: 125px;
  background-color: @backgroundcolor;
  padding-bottom: 69px;
}
</style>
